import React, { useState } from 'react';
import CalendarModal from './CalendarModal';
import CalendarWeekDay from './CalendarWeekDay';
import { useCalendarController } from './calendarContext';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import { makeSelectedEvent } from 'app/pages/TicketSalePage/slice/selectors';

const checkIfDayIsToday = (day: DateTime, today: DateTime) => {
  if (day.day !== today.day) return false;
  if (day.month !== today.month) return false;
  if (day.year !== today.year) return false;
  return true;
};

const CalendarDates: React.FC<{}> = () => {
  const {
    dateTimeFormat: { timezone },
  } = useSelector(makeSelectedEvent);
  const { selectedDate } = useCalendarController();
  const [firstDate] = useState(selectedDate);

  const today = DateTime.now().setZone(timezone);

  const weekDays = new Array(2)
    .fill(undefined)
    .map((_, index) => firstDate.plus({ days: index + 1 }));
  weekDays.unshift(firstDate);

  const firstDateIsToday = checkIfDayIsToday(weekDays[0], today);

  return (
    <div className="p-[12px] sm:p-[24px] grid sm:grid-cols-2 gap-[12px]">
      {weekDays.map((day, index) => (
        <CalendarWeekDay
          day={day}
          key={day.day}
          isToday={index === 0 ? firstDateIsToday : false}
          isTomorrow={index === 1 ? firstDateIsToday : false}
        />
      ))}
      <CalendarModal />
    </div>
  );
};

export default CalendarDates;
